// extracted by mini-css-extract-plugin
export default {"mainWrapper":"styles_mainWrapper__GExUv","resetPasswordFormWrapper":"styles_resetPasswordFormWrapper__Mcpry","slide-in-top":"styles_slide-in-top__uy4Gd","info":"styles_info__KhtOC"};